import React, {useState, useEffect,useReducer} from 'react'
import './css/QuizMenu.css'
import { AnimatePresence, motion } from 'framer-motion';
import AnimateHeight from 'react-animate-height';
import NoContentPopup from "./NoContentPopup";

//firebase stuff
import {firebase} from './firebase';
import {db} from './firebase';
import { addDoc,deleteDoc, doc, getDocs, collection, query, where,serverTimestamp, getDoc } from 'firebase/firestore';
import AnswerScreen from './AnswerScreen';
import AnswerScreenVerbs from './AnswerScreenVerbs';
import VerbsDisplay from './VerbsDisplay';
import { displayNounData,displayPhraseData,displayVerbData,displayVerbDataPast,getFirebaseData } from './displayQuizData';

//redux stuff
import { useSelector, useDispatch} from 'react-redux';

function QuizMenu() {

     const [noun, setNoun] = useState('');
     const [nounTranslation, setNounTranslation] = useState('');

     //verbs entered by user
     const [verbsObject, setVerbsObject] = useState({verb:'',infinitive:'', I:'', you:'', he:'', we:'', yall:'', they:''});
     const [verbsPastObject, setVerbsPastObject] = useState({verb:'',infinitive:'', I:'', you:'', he:'', we:'', yall:'', they:''});

     //verb answers pulled by DB. The displayNounData(), displayVerbData() etc selectes a random collection and sets these state values
     const [verbsAnswerObject, setVerbsAnswerObject] = useState({verb:'',infinitive:'', I:'', you:'', he:'', we:'', yall:'', they:''});
     const [verbsPastAnswerObject, setVerbsPastAnswerObject] = useState({verb:'',infinitive:'', I:'', you:'', he:'', we:'', yall:'', they:''});


     ////////////////////////////////////// Empty fields Reducers  /////////////////////////////////////////////////////////
     //using useReducer() bc we have to update multiple properties at once
     function missingReducer(verbsMissing,action){
          switch(action.type){
               case 'verb':{ return{ ...verbsMissing, verb: action.payload.verb} }
               case 'infinitive':{ return{ ...verbsMissing, infinitive: action.payload.infinitive} }
               case 'I':{ return{ ...verbsMissing, I: action.payload.I} }
               case 'you':{ return{ ...verbsMissing, you: action.payload.you} }
               case 'he':{ return{ ...verbsMissing, he: action.payload.he} }
               case 'we':{ return{ ...verbsMissing, we: action.payload.we} }
               case 'yall':{ return{ ...verbsMissing, yall: action.payload.yall} }
               case 'they':{ return{ ...verbsMissing, they: action.payload.they} }       
          }
     }

     //when using reducers, this is how to set up the 'state'
     const [verbsMissing, dispatch] = useReducer(missingReducer, {verb:false, I:false, you:false, he:false, we:false, yall:false, they:false});   

     function missingPastReducer(verbsPastMissing,action){
          switch(action.type){
               case 'verb':{ return{ ...verbsPastMissing, verb: action.payload.verb} }
               case 'infinitive':{ return{ ...verbsPastMissing, infinitive: action.payload.infinitive} }
               case 'I':{ return{ ...verbsPastMissing, I: action.payload.I} }
               case 'you':{ return{ ...verbsPastMissing, you: action.payload.you} }
               case 'he':{ return{ ...verbsPastMissing, he: action.payload.he} }
               case 'we':{ return{ ...verbsPastMissing, we: action.payload.we} }
               case 'yall':{ return{ ...verbsPastMissing, yall: action.payload.yall} }
               case 'they':{ return{ ...verbsPastMissing, they: action.payload.they} }       
          }
     }

     //when using reducers, this is how to set up the 'state'
     const [verbsPastMissing, dispatchPast] = useReducer(missingPastReducer, {verb:false, I:false, you:false, he:false, we:false, yall:false, they:false});
     ////////////////////////////////////// END Empty fields Reducers  /////////////////////////////////////////////////////////

     function readyForNewReducer(readyForNew,action){
          switch(action.type){
               case 'noun':{ return{ ...readyForNew, noun: action.payload.noun} }
               case 'verb':{ return{ ...readyForNew, verb: action.payload.verb} }
               case 'verbPast':{ return{ ...readyForNew, verbPast: action.payload.verbPast} }
               case 'phrase':{ return{ ...readyForNew, phrase: action.payload.phrase} }
          }
     }


     //this will prevent the content from changing everytime you click on a section to open it. It will only change when this state value changes
     const [readyForNew,dispatchReady] = useReducer(readyForNewReducer,{noun:true,verb:true,verbPast:true,phrase:true}); 
     const [readyForNewNoun,setReadyForNewNoun] = useState(true);
     const [readyForNewPhrase,setReadyForNewPhrase] = useState(true);
     const [readyForNewVerb,setReadyForNewVerb] = useState(true);
     const [readyForNewVerbPast,setReadyForNewVerbPast] = useState(true);

     
     ////////////handling the noun and phrase 'missing' when you commit to an empty field
     function missingNounPraseReducer(nounAndPhraseMissing,action){
          switch(action.type){
               case 'noun':{ return{ ...nounAndPhraseMissing, noun: action.payload.noun} }
               case 'phrase':{ return{ ...nounAndPhraseMissing, phrase: action.payload.phrase} }
          }
     }
     const [nounAndPhraseMissing,dispatchNounPhraseMissing] = useReducer(missingNounPraseReducer,{noun:false,phrase:false}); 


     const [dataFromDatabase,setDatabaseData] = useState([]);

     const [phrase, setPhrase] = useState('');
     const [phraseTranslation, setPhraseTranslation] = useState('');

     const [selectedSection, setSelectedSection] = useState(''); 
     const [active, setActive] = useState(''); 
     const [nounHeight, setNounHeight] = useState(36); 
     const [verbHeight, setVerbHeight] = useState(36); 
     const [phraseHeight, setPhraseHeight] = useState(36); 
     const [verbPastHeight, setVerbPastHeight] = useState(36); 
     
     const [isOpen, setIsOpen] = useState(false);

     const [nounOpen, setNounOpen] = useState(false);
     const [verbOpen, setVerbOpen] = useState(false);
     const [verbPastOpen, setVerbPastOpen] = useState(false);
     const [phraseOpen, setPhraseOpen] = useState(false);

     
     //redux
     const reduxUserID = useSelector((state) => state.isLoggedIn.reduxUserID);

     //firebase
     const nounsRef = collection(db,"users",reduxUserID,'nouns');
     const verbsRef = collection(db,"users",reduxUserID,'verbs');
     const verbsRefPast = collection(db,"users",reduxUserID,'verbsPast');
     const phraseRef = collection(db,"users",reduxUserID,'phrases');

     const [nounDBData, setNounDBData] = useState('');
     const [verbDBData, setVerbDBData] = useState('');
     const [verbPastDBData, setVerbPastDBData] = useState('');
     const [phraseDBData, setPhraseDBData] = useState('');
     
     //display
     const [displayNoun,setDisplayNoun] = useState('');
     const [displayPhrase,setDisplayPhrase] = useState('');

     const [answerNounTranslation,setAnswerNounTranslation] = useState('');
     const [answerPhraseTranslation,setAnswerPhraseTranslation] = useState('');



     //these will determine which 'wrong screens' to display
     const [wrongNoun,setWrongNoun] = useState(false);
     const [wrongVerb,setWrongVerb] = useState(false);
     const [wrongVerbPast,setWrongVerbPast] = useState(false);
     const [wrongPhrase,setWrongPhrase] = useState(false);


     //these will keep track of if the answer screens are opened/closed
     //they are set closed in the continueAfterError() function in this component
     const [answerScreenNoun,setanswerScreenNoun] = useState(false);
     const [answerSreenVerb,setAnswerSreenVerb] = useState('notTrueOrFalse');
     const [answerSreenVerbPast,setAnswerSreenVerbPast] = useState(false);
     const [answerScreenPhrase,setAnswerScreenPhrase] = useState(false);

     //these will determine if the popups display saying that theres no content yet
     //these are set at the top of stretch()
     const [noNounAvailable,setNoNounAvailable] = useState(false);
     const [noVerbAvailable,setNoVerbAvailable] = useState(false);
     const [noVerbPastAvailable,setNoVerbPastAvailable] = useState(false);
     const [noPhraseAvailable,setNoPhraseAvailable] = useState(false);


    useEffect(() => {
     //yes these are long but only called once at the start. They grab all the data from each collection and store it in state
     //then for the rest of the time, it's that state thats played with
     //im just trying to shorten this file. Its a mess
     getFirebaseData(nounsRef,'nouns',setDatabaseData,setNounDBData,setVerbDBData,setVerbPastDBData,setPhraseDBData,getDocs);
     getFirebaseData(verbsRef,'verbs',setDatabaseData,setNounDBData,setVerbDBData,setVerbPastDBData,setPhraseDBData,getDocs);
     getFirebaseData(verbsRefPast,'verbsPast',setDatabaseData,setNounDBData,setVerbDBData,setVerbPastDBData,setPhraseDBData,getDocs);
     getFirebaseData(phraseRef,'phrases',setDatabaseData,setNounDBData,setVerbDBData,setVerbPastDBData,setPhraseDBData,getDocs);
    
   }, [])



     const stretch = (current) => {
          
          /////if the user has not created any nouns, verbs or phrases, show a popup that they have no info
          ///nounDBData etc, are the results of previous DB queries stored in state
          if(nounDBData.length == 0 && current == 'nounArea'){
               setNoNounAvailable(true);
               return;
          }
          if(verbDBData.length == 0 && current == 'verbArea'){
               setNoVerbAvailable(true);
               return;
          }          
          if(verbPastDBData.length == 0 && current == 'verbAreaPast'){
               setNoVerbPastAvailable(true);
               return;
          }  
          if(phraseDBData.length == 0 && current == 'phraseArea'){
               setNoPhraseAvailable(true);
               return;
          }           
          
          setIsOpen(true);
          setActive(current);
 
          //////if an area is in an Answer screen mode, and you click another one, reload the content and shut the answer screen
          if(current != "nounArea" && answerScreenNoun == true){
               setanswerScreenNoun(false);//turn off answer screen
               setNounTranslation('');
               displayNounData(nounDBData,setDisplayNoun,setAnswerNounTranslation);
          }

          if(current != "verbArea" && answerSreenVerb == true){
               setAnswerSreenVerb(false);//turn off answer screen
               displayVerbData(verbDBData,setVerbsAnswerObject,verbsAnswerObject);
               setVerbsObject({...verbsObject, verb:'',infinitive:'',I:'',you:'',he:'',we:'',yall:'',they:''});
          }

          if(current != "verbAreaPast" && answerSreenVerbPast == true){
               setAnswerSreenVerbPast(false);//turn off answer screen
               displayVerbDataPast(verbPastDBData,setVerbsPastAnswerObject,verbsPastAnswerObject);
               setVerbsPastObject({...verbsPastObject, verb:'',infinitive:'',I:'',you:'',he:'',we:'',yall:'',they:''});
          }

          if(current != "phraseArea" && answerScreenPhrase == true){ 
               setAnswerScreenPhrase(false);//turn off answer screen 
               displayPhraseData(phraseDBData,setDisplayPhrase,setAnswerPhraseTranslation);
               setPhraseTranslation('');
          }


          ///////////////////////////////////////////////////////END closing Answer screens when other sections are clicked and opened

          //redundant but the only way for now. we cant use ternary ops in the <Animate> thing
          if(current == "nounArea"){
               
               setNounHeight('auto');
               setNounOpen("quizNounOPEN");
               //only grab the data when the thing is closed
               if(nounHeight != "auto" && readyForNewNoun == true){
                    //this takes all noun data from DB, grabs a single doc and sets all the individual states
                    displayNounData(nounDBData,setDisplayNoun,setAnswerNounTranslation);
                    setReadyForNewNoun(false);
               }
          }
          else{
              setNounHeight(30);
          }
          ////////////////////////////verb area
          if(current == "verbArea"){
               
              setVerbHeight('auto');
              setVerbOpen("quizVerbOPEN");
              if(readyForNew.verb == true){

                    //this takes all verb data from DB, grabs a single doc and sets all the individual states
                    displayVerbData(verbDBData,setVerbsAnswerObject,verbsAnswerObject);
                    dispatchReady({type:'verb', payload:{verb:false}}) 
              }
          }
          else{
              setVerbHeight(30);
          }
          /////////////////////////phrase area
          if(current == "phraseArea"){
              setPhraseHeight('auto');
              setPhraseOpen("quizPhraseOPEN");
               //only grab the data when the thing is closed
               if(phraseHeight != "auto" && readyForNewPhrase == true){
                    //this takes all verb data from DB, grabs a single doc and sets all the individual states
                    displayPhraseData(phraseDBData,setDisplayPhrase,setAnswerPhraseTranslation);
                    setReadyForNewPhrase(false);
               }
          }
          else{
              setPhraseHeight(30);
          }
          /////////////////////////verbs past
          if(current == "verbAreaPast"){
               setVerbPastHeight('auto');
               setVerbPastOpen("quizVerbPastOPEN");
               if(readyForNewVerbPast == true){
                    //this takes all verb data from DB, grabs a single doc and sets all the individual states
                    //displayVerbDataPast(verbPastDBData,setVerbPurePast,setDisplayVerbPast,setAnswerVerbPastTranslation,setAnswerVerbIPast,setAnswerVerbYouPast,setAnswerVerbHePast,setAnswerVerbWePast,setAnswerVerbYallPast,setAnswerVerbTheyPast);
                    displayVerbDataPast(verbPastDBData,setVerbsPastAnswerObject,verbsPastAnswerObject);
                    setReadyForNewVerbPast(false);
               }
           }
           else{
               setVerbPastHeight(30);
           }         
      }//end stretch()










     ///////////////////////////////checks the enterd data against the answers and display the correct/wrong screens ///////////////////////
     const checkNoun = () => {
          //set the 'missing - enter a value' thing if empty
          if(nounTranslation == '' ){ dispatchNounPhraseMissing({type:'noun', payload:{noun:true}}) }
          if(nounTranslation != '' ){
               
               setanswerScreenNoun(true);//this says its ready to open and run its code
          }
     }


     
     const checkVerb = () => {
          //this tracks when the answerScreen is open/closed. This way we know when to fire CSS animations 
          
          //we have to use useReducer() here bc we cant update the 'verbsMissing' object multiple times without it in this case
          //dont submit if any of the fileds are blank. If blank, point out which are blank by adding a css class 'missing'
          if(verbsObject.verb == '' ){ dispatch({type:'verb', payload:{verb:true}}) }
          if(verbsObject.infinitive == '' ){ dispatch({type:'infinitive', payload:{infinitive:true}}) }
          if(verbsObject.I == '' ){ dispatch({type:'I', payload:{I:true}}) }
          if(verbsObject.you == '' ){ dispatch({type:'you', payload:{you:true}}) }
          if(verbsObject.he == '' ){ dispatch({type:'he', payload:{he:true}}) }
          if(verbsObject.we == '' ){ dispatch({type:'we', payload:{we:true}}) }
          if(verbsObject.yall == '' ){ dispatch({type:'yall', payload:{yall:true}}) }
          if(verbsObject.they == '' ){ dispatch({type:'they', payload:{they:true}}) }

          //if none are blank, open the Results screen. Shit I have to change this whole thing
          if(verbsObject.infinitive != '' && verbsObject.I != '' && verbsObject.you != '' && verbsObject.he != '' && verbsObject.we != '' && verbsObject.yall != '' && verbsObject.they != ''){
               //setWrongVerb(true);//will open the wrong screen... i hope
               setAnswerSreenVerb(true);
          }
     }



     const checkVerbPast = () => {

          //dont submit if any of the fileds are blank. If blank, point out which are blank
          if(verbsPastObject.verb == '' ){ dispatchPast({type:'verb', payload:{verb:true}}) }
          if(verbsPastObject.infinitive == '' ){ dispatchPast({type:'infinitive', payload:{infinitive:true}}) }
          if(verbsPastObject.I == '' ){ dispatchPast({type:'I', payload:{I:true}}) }
          if(verbsPastObject.you == '' ){ dispatchPast({type:'you', payload:{you:true}}) }
          if(verbsPastObject.he == '' ){ dispatchPast({type:'he', payload:{he:true}}) }
          if(verbsPastObject.we == '' ){ dispatchPast({type:'we', payload:{we:true}}) }
          if(verbsPastObject.yall == '' ){ dispatchPast({type:'yall', payload:{yall:true}}) }
          if(verbsPastObject.they == '' ){ dispatchPast({type:'they', payload:{they:true}}) }

          //if none are blank, open the Results screen. Shit I have to change this whole thing
          if(verbsPastObject.infinitive != '' && verbsPastObject.I != '' && verbsPastObject.you != '' && verbsPastObject.he != '' && verbsPastObject.we != '' && verbsPastObject.yall != '' && verbsPastObject.they != ''){
               setAnswerSreenVerbPast(true);
          }
     }



     const checkPhrase = () => {
          if(phraseTranslation == '' ){ dispatchNounPhraseMissing({type:'phrase', payload:{phrase:true}}) }
          if(phraseTranslation != '' ){
               
               setAnswerScreenPhrase(true);
          }
     }

///////////////////////////////ENDS the checks enterd data against the answers and display the correct/wrong screens ///////////////////////


     //this is called in the <AnswerScreen /> components
     //by setting "Wrong" to false, it closes the "wrong" window
     const continueAfterError = (section) => {
          if(section == "noun"){
               setWrongNoun(false);
               setTimeout(() => {
                    setanswerScreenNoun(false);
                    setNounTranslation('');
                    //set this in timeout to prevent the next words answers from displaying 
                    //before the answer popup is closed from the previous word
                    displayNounData(nounDBData,setDisplayNoun,setAnswerNounTranslation);
               },200 );
               
               setReadyForNewNoun(false);
               
          }
          if(section == "verbArea"){
               dispatchReady({type:'verb', payload:{verb:true}}); 
               
               setTimeout(() => {
                   setAnswerSreenVerb(false); 
                   //note in noun about timeout()
                   displayVerbData(verbDBData,setVerbsAnswerObject,verbsAnswerObject);
                   setVerbsObject({...verbsObject, verb:'',infinitive:'',I:'',you:'',he:'',we:'',yall:'',they:''});
               },200 );
               
               dispatchReady({type:'verb', payload:{verb:false}}) 
          }
          if(section == "verbAreaPast"){
               setWrongVerbPast(false);
               setTimeout(() => {
                    setAnswerSreenVerbPast(false); 
                    setVerbsPastObject({...verbsPastObject, verb:'',infinitive:'',I:'',you:'',he:'',we:'',yall:'',they:''});
                    //note in noun about timeout()
                    displayVerbDataPast(verbPastDBData,setVerbsPastAnswerObject,verbsPastAnswerObject);
                },200 );
                
                setReadyForNewVerbPast(false);
          }
          if(section == "phrase"){
               setWrongPhrase(false);
               setTimeout(() => {
                    setAnswerScreenPhrase(false);
                    setPhraseTranslation('');
                    //note in noun about timeout()
                    displayPhraseData(phraseDBData,setDisplayPhrase,setAnswerPhraseTranslation);
               },200 );
               
               // setReadyForNewPhrase(false);              
          }
     }//continueAfterError()



     //// varients allow for conditional settings in Framer Motion
     const variants = {
        open: { opacity: 1, scale: 1.2 },
        closed: { opacity: 0, scale: 1  },
     }

     return (
          <motion.div initial={{y:-768, opacity:0}} animate={{y:0, opacity:1}} exit={{y:768, opacity:0}} transition={{duration:0.2, ease: "easeOut"}}>
          {/* <div className='pageTitles'> Quiz your dumb ass</div> */}
          
          <div className='quizMenuContainer'>
               
               {/* ////////////////////////////////////////Noun area //////////////////////////////////////////////// */}
               <div 
                    className={ active == 'nounArea' ? "quizMenuOptionWrapper redBorder " + nounOpen  : 'quizMenuOptionWrapper'}
                    onClick = { () =>{ stretch("nounArea") }}
               >
                    
                    <NoContentPopup text={"You have no nouns yet"} nothingAvailable={noNounAvailable} />

                    <AnswerScreen section={"noun"} 
                         userInput={nounTranslation}
                         answer={answerNounTranslation} 
                         continueAfterError={continueAfterError} 
                         //wrong={wrongNoun}
                         readyToOpen={answerScreenNoun} 
                    />


                    <div className='paddingEffect'>
                         <AnimateHeight   
                              duration={ 200 }
                              height={nounHeight}
                         >
                                   <div className='textInputTitle'>
                                        <p style = {{color: active == 'nounArea' ? "#fff" : "" }}>Test Your Nouns</p>
                                   </div>

                                   <div className='question'>{displayNoun}</div>

                                   <input type='text' value={nounTranslation} 
                                        placeholder={nounAndPhraseMissing.noun ? "Enter Value" : "translation for " + displayNoun } 
                                        className={ nounAndPhraseMissing.noun ? 'textInputField missing' : 'textInputField'}
                                        onChange = {(event) => setNounTranslation(event.target.value)} 
                                        onFocus = { () => dispatchNounPhraseMissing({type:'noun', payload:{noun:false}}) }
                                   />
                                   <motion.button 
                                        className='addButton'
                                        onClick={checkNoun} 
                                        animate={ active == 'nounArea' ? "open" : "closed"}
                                        transition={{ duration: 0.1}}
                                        variants={variants}
                                        style = {{pointerEvents: active == 'nounArea' ? "" : "none"}} //so you cant click button before its visible
                                   >
                                   Check
                                   </motion.button>  


                         </AnimateHeight>
                   </div>  {/* //end padding effect */}
               

               </div>  {/* //end noun*/}



               {/* ////////////////////////////////////////Verb area PRESENT //////////////////////////////////////////////// */}
               <div 
                    className={ active == 'verbArea' ? "quizMenuOptionWrapper redBorder " + verbOpen : 'quizMenuOptionWrapper'}
                    onClick = { () =>{ stretch("verbArea") }}
                 >

                    <NoContentPopup text={"You have no verbs yet"} nothingAvailable={noVerbAvailable} />
                    
                    <AnswerScreenVerbs section={"verbArea"} 
                         answerSreenVerb = {answerSreenVerb}
                         setAnswerSreenVerb = {setAnswerSreenVerb}
                         verbsObject = {verbsObject} 
                         verbsAnswerObject = {verbsAnswerObject} 
                         continueAfterError={continueAfterError} 
                         //wrong={wrongVerb} 
                         stretch = {stretch}
                         readyForNew = {readyForNew.verb}
                         setReadyForNew = {setReadyForNewVerb}
                    />
    

                    <div className='paddingEffect'>
                         <AnimateHeight   
                              duration={ 200 }
                              height={verbHeight}
                         >
                                 
                                 <VerbsDisplay 
                                        active = {active}
                                        verbsAnswerObject = {verbsAnswerObject}
                                        verbsObject = {verbsObject}
                                        verbsMissing = {verbsMissing}
                                        dispatch = {dispatch}
                                        checkVerb = {checkVerb}
                                        verbHeight = {verbHeight}
                                        setVerbsObject = {setVerbsObject}
                                        pastPresent = {"present"}
                                   />

                                   <div className='quizButtonHolder'>
                                        <motion.button 
                                             className='addButton'
                                             onClick={checkVerb} 
                                             animate={ active == 'verbArea' ? "open" : "closed"}
                                             transition={{ duration: 0.1}}
                                             variants={variants}
                                             style = {{pointerEvents: active == 'verbArea' ? "" : "none"}} //so you cant click button before its visible
                                        >
                                        Check
                                        </motion.button>  
                                   </div> 

                         </AnimateHeight>
                   </div>  {/* //end padding effect */}
               

               </div>  {/* //end verb*/}



 {/* ////////////////////////////////////////Verb area PAST TENSE //////////////////////////////////////////////// */}
               <div 
                    className={ active == 'verbAreaPast' ? "quizMenuOptionWrapper redBorder " + verbPastOpen : 'quizMenuOptionWrapper'}
                    onClick = { () =>{ stretch("verbAreaPast") }}
                 >

                    <NoContentPopup text={"You have no verbs yet"} nothingAvailable={noVerbPastAvailable} />

                    <AnswerScreenVerbs section={"verbAreaPast"} 
                         answerSreenVerb = {answerSreenVerbPast}
                         setAnswerSreenVerb = {setAnswerSreenVerbPast}
                         verbsObject = {verbsPastObject} 
                         verbsAnswerObject = {verbsPastAnswerObject} 
                         continueAfterError={continueAfterError} 
                         stretch = {stretch}
                         readyForNew = {readyForNewVerbPast}
                         setReadyForNew = {setReadyForNewVerbPast}
                    />




                    <div className='paddingEffect'>
                         <AnimateHeight   
                              duration={ 200 }
                              height={verbPastHeight}
                         >

                                   <VerbsDisplay 
                                        active = {active}
                                        verbsAnswerObject = {verbsPastAnswerObject}
                                        verbsObject = {verbsPastObject}
                                        verbsMissing = {verbsPastMissing}
                                        dispatch = {dispatchPast}
                                        checkVerb = {checkVerbPast}
                                        verbHeight = {verbPastHeight}
                                        setVerbsObject = {setVerbsPastObject}
                                        pastPresent = {"past"}
                                   />
                                   <div className='quizButtonHolder'>
                                        <motion.button 
                                             className='addButton'
                                             onClick={checkVerbPast} 
                                             animate={ active == 'verbAreaPast' ? "open" : "closed"}
                                             transition={{ duration: 0.1}}
                                             variants={variants}
                                             style = {{pointerEvents: active == 'verbAreaPast' ? "" : "none"}} //so you cant click button before its visible
                                        >
                                        Check
                                        </motion.button>  
                                   </div>

                         </AnimateHeight>
                   </div>  {/* //end padding effect */}
               

               </div>  {/* //end Past Tense verb*/}



 {/* ////////////////////////////////////////Phrase area //////////////////////////////////////////////// */}
               <div 
                    className={ active == 'phraseArea' ? "quizMenuOptionWrapper redBorder " + phraseOpen : 'quizMenuOptionWrapper'}
                    onClick = { () =>{ stretch("phraseArea") }}
                 >
               
                    <NoContentPopup text={"You have no phrases yet"} nothingAvailable={noPhraseAvailable} />

                    <AnswerScreen section={"phrase"} 
                         userInput={phraseTranslation}
                         answer={answerPhraseTranslation} 
                         continueAfterError={continueAfterError} 
                         //wrong={wrongNoun}
                         readyToOpen={answerScreenPhrase} 
                    />

                    <div className='paddingEffect'>
                         <AnimateHeight   
                              duration={ 200 }
                              height={phraseHeight}
                         >
                                   <div className='textInputTitle'>
                                        <p style = {{color: active == 'phraseArea' ? "#fff" : "" }}>Test Your Phrases</p>
                                   </div>

                                   <div className='question'>{displayPhrase}</div>

                                   <input type='text' value={phraseTranslation} 
                                        placeholder={nounAndPhraseMissing.phrase ? "Enter Value" : "translation for " + displayPhrase } 
                                        className={ nounAndPhraseMissing.phrase ? 'textInputField missing' : 'textInputField'}
                                        onChange = {(event) => setPhraseTranslation(event.target.value)} 
                                        onFocus = { () => dispatchNounPhraseMissing({type:'phrase', payload:{phrase:false}}) }
                                   />
                                   <motion.button 
                                        className='addButton'
                                        onClick={checkPhrase} 
                                        animate={ active == 'phraseArea' ? "open" : "closed"}
                                        transition={{ duration: 0.1}}
                                        variants={variants}
                                        style = {{pointerEvents: active == 'phraseArea' ? "" : "none"}} //so you cant click button before its visible
                                   >
                                   Check
                                   </motion.button>  


                         </AnimateHeight>
                   </div>  {/* //end padding effect */}
               

               </div>  {/* //end phraseArea*/}
          </div>
          </motion.div>
     )
}

export default QuizMenu
